"use client"
import React, { useEffect } from 'react';
import { ActiveStream } from '../types';
import xhook from "xhook";
import ReactPlayer from 'react-player';
import { DVIcon } from '@develos/next-components';

interface StreamPlayerProps {
  width?: string | number;
  height?: string | number;
  stream?: ActiveStream;
  onPlayerReady?: () => void;
  onError?: (e: any) => void;
}

const StreamPlayer: React.FC<StreamPlayerProps> = ({
  width,
  height,
  stream,
  onPlayerReady,
  onError
}) => {

  const uId = stream?.uId;
  const source = stream?.source;

  useEffect(() => {
    xhook.enable();
    xhook.before((request: any, callback: () => void) => {
      if (request.url.includes('live')) {
        const uri = new URL(request.url, undefined);
        request.url = `https://${uri.host}${uri.pathname}?sourceUID=${uId}`;
      }
      callback();
    });

    return () => {
      xhook.disable();
    }
  }, [uId])


  if (!source) {

    return (
      <div className="rm-flex rm-flex-col rm-justify-center rm-items-center rm-min-h-[640px] rm-bg-[#2f353a] rm-font-bold rm-text-xl rm-text-white">
        <DVIcon
          name="Video"
          className='rm-w-12 rm-h-12 rm-mt-[-24px] rm-mb-6'
        />
        <div className='rm-text-center'>Nawiąż połączenie z wybraną kamerą, aby zobaczyć obraz</div>
      </div>
    )
  }

  return (
    <div className='rm-relative rm-pt-[56.25%]'>
      <ReactPlayer
        className='rm-absolute rm-top-0 rm-left-0'
        url={source.src}
        width={width}
        height={height}
        pip={false}
        muted={true}
        playing={true}
        controls={true}
        config={{
          file: {
            forceHLS: true
          }
        }}
        onPlay={() => onPlayerReady?.()}
        onError={e => onError?.(e)}
      />
    </div>
  );
};

export default StreamPlayer;